module.exports = __webpack_public_path__ + "static/media/unfold.e679aa39.svg";